<template>
  <div class="nav-wrapper" v-if="$parent.nav.nav">
    <b-navbar style="background-color: transparent;">
      <b-navbar-nav small>
      <!--
          <li class="nav-item" v-if="$parent.nav.home && !hide.includes('home')">
            <b-button size="sm" v-if="$parent.eventid == '-'"
              class="material-vue nav_btn"
              style="min-width:45px;"
              title="Go to Home" @click="goHomePrompt()">
              home</b-button>
            <b-button size="sm" v-if="$parent.eventid && $parent.eventid != '-'"
              class="nav_btn nav_btn_text"
              style="min-width:45px;"
              title="Go to Event" @click="$parent.goEvent()">
              EVENT</b-button>
          </li>
     -->
          <li class="nav-item" v-if="$parent.nav.close_iframe">
            <b-button size="sm" style="min-width:45px;margin: 0 0.1rem;"
              variant="danger"
              @click="$parent.closeIframe()">
              Close</b-button>
          </li>
<!--
          <li class="nav-item" v-if="$parent.nav.adm_acc">
            <b-button size="sm"
              style="min-width:45px;margin: 0 0.1rem;"
              :variant="($parent.nav.rname == 'admacc'?'primary':'secondary')"
              @click="$router.currentRoute.name != 'admacc' && goAdmAcc()">
              Top
            </b-button>
          </li>
-->
          <li class="nav-item" v-if="$parent.nav.adm_users"> 
            <b-button size="sm"
              style="min-width:45px;margin: 0 0.1rem;"
              :variant="($parent.nav.rname == 'admuser'?'primary':'secondary')"
              @click="$router.currentRoute.name != 'admuser' && goAdmUsers()">
              Users
            </b-button>
          </li>
          </li>
<!--
          <li class="nav-item land_only" v-if="$parent.nav.title">
            <span class="view_name nav-link nav-link-disabled"
              style="margin-left: 0.2rem;">
              {{ $parent.nav_title }}
            </span>
          </li>
-->
          <li class="nav-item" v-if="$parent.nav.login">
            <router-link
              :to="{ name: 'login' }"
              style="border:none;margin:0;padding:0.1rem 0.5rem;"
              class="btn btn-primary btn-sm">
              Login
            </router-link>
          </li>
          <li class="nav-item" v-if="$parent.nav.back_toroom">
            <router-link
              :to="$parent.getToRoom()"
              variant="nav-secondary"
              class="header_button">
              Back
            </router-link>
          </li>
          <li class="nav-item" v-if="$parent.nav.back_hist">
            <b-button size="sm" style="margin:0 0.1rem;"
              @click="$parent.goBack()"
              variant="nav-secondary"
              class="header_button">
              Back
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.goloc_cont">
            <b-button size="sm" style="margin:0 0.1rem;"
              @click="$parent.getGoLocOrHome()"
              variant="nav-secondary"
              class="header_button">
              Continue Using Browser
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.back_settings">
            <b-button size="sm" style="margin:0 0.1rem;"
              @click="$parent.goSettings()"
              variant="nav-secondary"
              class="header_button">
              Back
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.stats && $parent.canShowStats">
            <b-button size="sm" style="margin:0 0.1rem;"
              @click="$parent.goStats()"
              variant="nav-secondary"
              class="header_button">
              Statistics
            </b-button>
          </li>
          <li v-if="$parent.nav.room_search || ($parent.nav.aud_search && !hide.includes('search'))">
            <search-transfer
              :pastRooms="$parent.pastRooms"
              :add2Past="$parent.add2Past"
              v-on:room="transfer_room"
              v-on:search="do_search"
              placeholder="Goto @Room"
            >
            </search-transfer>
          </li>
          
          <li class="nav-item" v-if="$parent.nav.adm">
            <b-button size="sm" style="margin:0 0.1rem;"
              @click="goAdmUsers()"
              variant="nav-secondary"
              class="header_button">
              Admin
            </b-button>
          </li>
        </b-navbar-nav>

        <b-navbar-nav small class="mx-auto">
          <li class="nav-item" v-if="!mic_hide && $parent.nav.cap_panel && $parent.amStreaming()">
            <b-button size="sm" class="material-vue nav_btn"
               variant="nav-secondary"
               title="(Alt-a) Mute your microphone"
               v-if="mic"
               @click="doMicOff">
               mic
            </b-button>
            <b-button size="sm" class="material-vue nav_btn"
               variant="nav-danger"
               title="(Alt-a) Unmute your microphone"
               v-if="!mic"
               @click="doMicOn">
               mic_off
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.cap_panel && $parent.show_cam_btn && $parent.amStreaming() && $parent.mydevice.share_state == 'off'">
            <b-button size="sm" class="material-vue nav_btn"
               variant="nav-secondary"
               title="Turn your camera off"
               v-if="!$parent.video_off"
               @click="doCamOff">
               videocam
            </b-button>
            <b-button size="sm" class="material-vue nav_btn"
               variant="nav-danger"
               title="Turn your camera on"
               v-if="$parent.video_off"
               @click="doCamOn">
               videocam_off
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.unmute">
            <b-button size="sm" class="material-vue nav_btn"
               variant="nav-secondary"
               title="(Alt-Shift-M) Mute your speaker"
               v-if="$parent.unmute"
               @click="doMute">
               volume_up
            </b-button>
            <b-button size="sm" class="material-vue nav_btn"
               variant="nav-danger"
               title="(Alt-Shift-M) Unmute your speaker"
               v-if="!$parent.unmute"
               @click="doUnmute">
               volume_off
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.cast_ask_cb">
            <b-button size="sm" class="nav_btn"
               style="margin:0;font-size:1rem;line-height:1.2rem;"
               variant="primary"
               @click="$parent.nav.cast_ask_cb">
               Ask Question
            </b-button>
          </li>
<!--
          <li class="nav-item" v-if="$parent.nav.cap_panel && $parent.amStreaming()">
            <b-button size="sm" class="nav_btn" style="line-height: 0.9rem;"
               variant="primary"
               @click="testkill(1)">
               P
            </b-button>
            <b-button size="sm" class="nav_btn" style="line-height: 0.9rem;"
               variant="danger"
               @click="testkill(2)">
               S
            </b-button>
            <div class="btn nav_btn" style="background-color:white;line-height: 0.9rem;width:2rem;font-size:0.7rem;padding:0;"
              > {{ $parent.tmp_cur_low }} </div>
            <div class="btn nav_btn" style="background-color:white;line-height: 0.9rem;width:2rem;font-size:0.7rem;padding:0;"
             > {{ $parent.tmp_max_low }} </div>
          </li>
-->
        </b-navbar-nav>
        
        <!-- Right aligned nav items -->
        <b-navbar-nav small>
          <li class="nav-item" v-if="$parent.nav.myroom">
            <b-button size="sm" style="margin:0 0.1rem;"
              @click="$parent.goMyRoom()"
              variant="nav-secondary"
              class="header_button">
              My Room
            </b-button>
          </li>
          <li class="nav-item" style="margin-right:0;" v-if="false && $parent.mydevice.can_capture && $parent.amStreaming() && showStopShare() && $parent.mydevice.open_annotator">
            <b-button size="sm" class="material-vue ttip_annotate"
                title="Open Annotation"
                v-if="!($parent.mydevice.annotate_url)"
                style="min-width:35px;line-height:1.2rem;"
                @click="openAnnotation">
              edit
            </b-button>
            <b-button size="sm" class="material-vue ttip_annotate"
                title="Close Annotation"
                v-if="($parent.mydevice.annotate_url)"
                style="min-width:35px;line-height:1.2rem;color:rgb(200,150,50);"
                @click="closeAnnotation">
              edit
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.kvm && kvm_client_active">
            <b-button size="sm" style="margin: 0 0.1rem;"
               variant="danger" @click="stopKVMClient">
               End Remote Access
            </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.kvm && kvm_server_active">
            <b-button size="sm" style="margin: 0 0.1rem;"
               variant="danger" @click="stopKVMServer">
               End Remote Access
            </b-button>
          </li>

          <li class="nav-item"
            v-if="$parent.nav.ss && $parent.amStreaming()">
            <b-button size="sm" class="material-vue nav_btn"
              style="min-width:30px;font-size:1.7rem;border:none;padding: 0.3rem 0;"
              variant="nav-secondary"
              v-show="$parent.mydevice.share_state == 'off'"
              title="Start Screen Sharing" @click="startShare">
              present_to_all
            </b-button>
            <b-button size="sm" class="material-vue nav_btn"
                style="min-width:30px;font-size:1.7rem;border:none;padding: 0.3rem 0;"
                variant="nav-danger"
                v-show="$parent.mydevice.share_state != 'off'"
                title="Stop Screen Sharing" @click="stopShare">
                present_to_all
            </b-button>
            <b-button size="sm" class="material-vue nav_btn"
                v-show="$parent.mydevice.share_state != 'off' && $parent.mydevice.swap_share"
                variant="nav-warning"
                style="min-width:30px;padding: 0.3rem 0;"
                title="Swap Screen Share and Camera" @click="swapShare">
                switch_video
            </b-button>
          </li>
          <li class="nav-item" title="Start Streaming"
            v-if="$parent.nav.cap_panel_download">
            <b-button size="sm"
              v-if="can_join"
              style="min-width:80px;margin: 0 0.3rem;line-height:1.2rem;font-weight:600;"
              @click="$parent.goDownload()">
              {{ textCapPanelJoin() }}
            </b-button>
          </li>
          <li class="nav-item"
            v-if="$parent.nav.cap_panel && !local_share.open">
            <b-button size="sm" class="material-vue nav_btn capturestate"
              v-if="$parent.amStreaming()"
              title="Audio / Video Settings"
              style="font-size:1.7rem; padding: 0.25rem 0;"
              variant="nav-danger"
              @click="$parent.showPanelManual()">
              more_horiz
            </b-button>
            <b-button size="sm" class="material-vue nav_btn capturestate"
              v-if="!$parent.amStreaming()"
              title="Join Room"
              variant="nav-success"
              @click="$parent.showPanelManual()">
              phone
            </b-button>
          </li>
          <li class="nav-item" v-if="local_share.open">
             <b-button size="sm"
              style="min-width:80px;margin: 0 0.3rem;line-height:1.2rem;font-weight:600;color:rgb(200,150,50);"
              @click="close_local_share">
              CLOSE
             </b-button>
          </li>
          <li class="nav-item" v-if="$parent.nav.settings && $parent.is_mod"
            style="position:relative;">
            <b-button size="sm" class="material-vue nav_btn"
              variant="nav-secondary"
              @click="quickClick()">
              settings
            </b-button>
            <div v-if="quickmenu"
                @mouseleave="quickmenu=false;">
             <ul class="dropdown-menu dropdown-menu-right quickmenu">
              <li>
                <b-form-checkbox v-model="$parent.ctrl.viewing"
                   @change="quickCtrl('viewing')"
                   value="open" unchecked-value="closed"
                   switch>
                   <span class="quickmenu_item">
                     access</span>
                   <span v-if="$parent.ctrl.viewing=='open'"
                     class="quickmenu_val" style="color:green;">open
                   </span>
                   <span v-if="$parent.ctrl.viewing!='open'"
                     class="quickmenu_val" style="color:red;">{{$parent.ctrl.viewing}}
                   </span>
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox v-model="$parent.ctrl.privmode"
                   @change="quickCtrl('privmode',$event)"
                   switch>
                   <span class="quickmenu_item">
                   privacy</span>
                   <span v-if="$parent.ctrl.privmode"
                     class="quickmenu_val" style="color:green;">on
                   </span>
                   <span v-if="!$parent.ctrl.privmode"
                     class="quickmenu_val" style="color:red;">off
                   </span>
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox v-model="$parent.ctrl.state.pl"
                   @change="quickCtrl('pl')"
                   value="autopt" unchecked-value="autop5"
                   switch>
                   <span class="quickmenu_item">
                   layout</span>
                   <span v-if="$parent.ctrl.state.pl=='autop5'"
                     class="quickmenu_val" style="color:green;">auto
                   </span>
                   <span v-if="$parent.ctrl.state.pl=='autopt'"
                     class="quickmenu_val" style="color:green;">share
                   </span>
                   <span v-if="$parent.ctrl.state.pl.indexOf('auto')"
                     class="quickmenu_val" style="color:red;">custom
                   </span>
                </b-form-checkbox>
              </li>
              <li v-if="$parent.ctrl.alert">
                <b-form-checkbox v-model="$parent.ctrl.alert.not_sil"
                   @change="quickCtrl('silenced')"
                   switch>
                   <span class="quickmenu_item">
                   alerts</span>
                   <span v-if="!$parent.ctrl.alert.silenced"
                     class="quickmenu_val" style="color:green;">on
                   </span>
                   <span v-if="$parent.ctrl.alert.silenced"
                     class="quickmenu_val" style="color:red;">off
                   </span>
                </b-form-checkbox>
              </li>
              <li v-if="$parent.nav.aarec" style="position:relative;">
                <b-button v-if="!$parent.ctrl.script_active"
                   class="quickmenu_script"
                   @click="new_transcript()"
                   variant="success">
                   new transcript
                </b-button>
                <b-button v-if="$parent.ctrl.script_active"
                   class="quickmenu_script"
                   @click="stop_transcript()"
                   variant="danger">
                   stop transcript
                </b-button>
              </li>
              <li v-if="$parent.nav.aarec" style="position:relative;">
                <b-button v-if="aarec_status == 'disabled'"
                   disabled
                   class="quickmenu_aabtn"
                   variant="outline-secondary">
                   audio rec disabled
                </b-button>
                <b-button v-if="aarec_status == 'off'"
                   class="quickmenu_aabtn"
                   @click="quickAARec('start')"
                   variant="success">
                   start audio recording
                </b-button>
                <b-button v-if="aarec_status == 'pending'" 
                   class="quickmenu_aabtn"
                   @click="quickAARec('stop')"
                   variant="warning">
                   pending
                </b-button>
                <div v-if="aarec_status == 'rec'"
                   class="btn btn-danger quickmenu_aabtn"
                   @click="quickAARec('stop')"
                   variant="danger">
                   <span class="quickmenu_aastop">stop</span>
                   <span> recording</span>
                   <span class="quickmenu_aaelp"> {{aarec_elapsed}}</span>
                </div>
                <span v-if="aarec_status == 'rec'" class="quickmenu_aahov">
                  @{{aarec_room}}
                </span>
              </li>
              <li v-if="$parent.ctrl.enable_desk" style="position:relative;">
                <b-button v-if="desktop.state == 'off'"
                   class="quickmenu_deskbtn"
                   @click="quickBrowser('start')"
                   variant="success">
                   launch shared desktop
                </b-button>
                <b-button v-if="desktop.state == 'pending'"
                   class="quickmenu_deskbtn"
                   @click="quickBrowser('stop')"
                   variant="outline-warning">
                   desktop starting
                </b-button>
                <b-button v-if="desktop.state == 'active'"
                   class="quickmenu_deskbtn"
                   @click="quickBrowser('stop')"
                   variant="outline-danger">
                   end desktop session
                </b-button>
              </li>
              <li style="text-align:center;" v-if="quickVMPending">
                <div class="quickmenu_vm">
                  New Voicemail
                </div>
              </li>
              <li style="text-align:center;">
                <a class="quickmenu_all"
                  @click="spawnSettings()">
                  All Settings
                </a>
              </li>
             </ul>
            </div>
          </li>

          <li class="nav-item"
            style="position:relative;">
            <b-button size="sm" class="material-vue nav_btn"
              variant="nav-secondary"
              @click="accountClick()"
              >
              person
            </b-button>
            <div v-if="showaccount"
               @click="showaccount=false;"
               @mouseleave="showaccount=false;">
            <ul class="dropdown-menu dropdown-menu-right my-dropdown">
            <li role="presentation" class="small" style="text-align:center;padding:0.15rem 0.25rem;">
               <div style="width:100%;cursor:default;"> {{ $parent.currentUser.short_name }} </div>
            </li>
            <li role="presentation" class="small" style="text-align:center;padding:0.15rem 0.25rem;"
               v-if="$parent.cur_room_dname">
               <div style="width:100%;cursor:default;"> {{ $parent.cur_room_dname }} </div>
            </li>
            <b-dropdown-divider class="" v-if="$parent.cur_room_dname">
            </b-dropdown-divider>
            <b-dropdown-item v-if="$parent.nav.home && !hide.includes('home')">
              <a class="nav-link small" v-if="$parent.eventid == '-'"
                type="button"
                style="color:#343a40"
                @click="goHomePrompt()">
                Home
              </a>
              <a class="nav-link small" v-if="$parent.eventid && $parent.eventid != '-'"
                type="button"
                style="color:#343a40"
                @click="$parent.goEvent()">
                Event
              </a>
            </b-dropdown-item>
            <b-dropdown-item v-if="$parent.currentUser.adm_acc">
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="$parent.goStatViewer"
                >Stat Viewer</a>
            </b-dropdown-item>
            <b-dropdown-item v-if="$parent.nav.menu_newwindow && !hide.includes('newwin')">
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="spawnWindow"
                >New Window</a>
            </b-dropdown-item>
            <b-dropdown-item v-if="false">
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="goSysTests"
                >System Tests</a>
            </b-dropdown-item>
            <b-dropdown-item v-if="$parent.nav.menu_debug">
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="debugToggle"
                >Debug</a>
            </b-dropdown-item>
            <b-dropdown-item v-if="$parent.mydevice.is_app">
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="doRefresh"
                >Refresh</a>
            </b-dropdown-item>
            <b-dropdown-divider> </b-dropdown-divider>
            <b-dropdown-item>
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="$parent.goAccount"
                >Account</a>
            </b-dropdown-item>
            <b-dropdown-item  v-if="$parent.nav.menu_arc && $parent.is_mod">
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="$parent.goRoomArchive"
                >Room Library</a>
            </b-dropdown-item>
            <b-dropdown-item>
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="showAbout"
                >About</a>
            </b-dropdown-item>
            <b-dropdown-item>
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="$parent.openHelp"
                >Help</a>
            </b-dropdown-item>
            <b-dropdown-item>
              <a class="nav-link small"
                type="button"
                style="color:#343a40"
                @click="signOut"
                >Sign Out</a>
            </b-dropdown-item>

             </ul>
            </div>
          </li>

        </b-navbar-nav>
    </b-navbar>
    <b-modal id="bv-about" size="md" title="About" hide-footer>
       <li> Name: {{ this.$parent.currentUser.first_name+" "+this.$parent.currentUser.last_name }} </li>
       <li> Email: {{ this.$parent.currentUser.email }} </li>
       <li> Domain: {{ this.$parent.currentUser.acc }} </li>
       <li> Site Release: {{ this.about.rel }} </li>
       <li> Site Version: {{ this.about.site_version }} </li>
       <li> App Version:  {{ this.about.app_version }} </li>
       <li> OS Version:  {{ this.about.os_version }} </li>
       <li> Upload Region: {{ this.about.upload_loc }} </li>
       <li> Download Region:  {{ this.about.download_loc }} </li>
       <li v-if="this.about.threads"> Threads: {{ this.about.threads }} </li>
       <li> Vid/PT:  {{ this.about.bl }} </li>
    </b-modal>
    <b-modal id="bv-kvm" size="md" hide-header hide-footer no-close-on-backdrop
       >
       <div> The presenter {{ kvm.dn }} has requested to control your desktop. </div>
       <b-button-group>
         <b-button class="sm" style="padding:0 1rem;" @click="openKVMServer" variant="danger">
           Give Control
         </b-button>
       </b-button-group>
       <b-button-group class="float-right">
         <b-button class="sm" style="padding:0 1rem;" @click="cancelKVMServer">
           Cancel
         </b-button>
       </b-button-group>
    </b-modal>
    <b-alert show fade class="position-fixed" variant="warning" v-model="$parent.showCookieWarning">
      This site uses cookies. By continuing to browse this website, you accept the use of cookies.
      <b-button-group class="float-right">
         <b-button size="sm" variant="warning" @click="$parent.acceptsCookies()"> Okay </b-button>
      </b-button-group>
    </b-alert>

    <b-modal id="bv-home-prompt" size="md" title="Are you sure you want to leave the room?" hide-footer>
       <div style="padding: 1vw 0px">
         <b-button-group class="">
           <b-button class="mb-0" size="sm" @click="goHomePromptClick()">
             Continue to Home
           </b-button>
         </b-button-group>
         <b-button-group class="float-right">
           <b-button class="mb-0" size="sm" @click="$bvModal.hide('bv-home-prompt')">
             Cancel
           </b-button>
         </b-button-group>
       </div>
       <div style="padding: 1vw 0px">
          <b-checkbox
            v-model="stopHomePrompt"
          >
            Do not prompt me again for this.
          </b-checkbox>
       </div>
    </b-modal>
    
  </div> 
</template>

<script>
import store from "../store";
import vx_api from "../vuemix";
import SearchTransfer from "../components/SearchTransfer";

export default {
  name: "Navigation",
  components: { SearchTransfer
  },
  data() {
    return {
      local_share: {open: false, uid: null},
      can_join: true,
      valRoomSearch: "",
      valAudSearch: "",
      about: {},
      kvm: {},
      kvm_server_active: false,
      kvm_client_active: false,
      pastPhones: [],
      mic: false,
      mic_hide: false,
      hide: [],
      stopHomePrompt: false,
      showaccount: false,
      quickmenu: false,
      quickVMPending: false,
      aarec_status: "disabled",
      aarec_elapsed: null,
      desktop: { state: "off" },
      transcribe: {
        audible: false,
        open: false,
        tuid: "",
      },
    };
  },
  watch: {
  },
  created() {
    this.loadPastPhones();
  },
  computed: {
  },
  mounted() {
    let nav = this;
    window.vx_nav_callback = function(k, v) {
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("nav:"+k+" "+JSON.stringify(v)); }
      if (k == "title") {
        nav.$parent.nav_title = v;
      } else if (k == "unmute") {
        nav.$parent.unmute = v;
      } else if (k == "unmute_cbs") {
        nav.do_mute = v.do_mute;
        nav.do_unmute = v.do_unmute;
      } else if (k == "mic") {
        nav.mic = v;
      } else if (k == "michide") {
        nav.mic_hide = v;
      } else if (k == "hide") {
        nav.hide = v;
      } else if (k == "exit_room") {
        if (nav.$parent.exit_listener) {
           nav.$parent.exit_listener();
        }
      } else if (k == "roomSearchVal") {
        nav.valRoomSearch = v;
      } else if (k == "openMirror") {
        nav.spawnMirror();
      } else if (k == "can_join") {
        nav.can_join = v;
      } else if (k == "goto_settings") {
        nav.$router.push({ name: 'settings' });
      } else if (k == "goto_share") {
        let routeData =
            nav.$router.resolve({ name: 'share', params: {
                                  uid:v.room,
                                  userid:v.userid }});
        window.open_if_not(routeData.href, '_blank', 'scrollbars=yes');
      } else if (k == "open_chat") {
        nav.$parent.openChat(v.acc, v.room);
      } else if (k == "is_open_chat") {
        if (!nav.$parent.mydevice.multi_window) { return false; }
        return nav.$parent.isOpenChat(v.acc, v.room);
      } else if (k == "goto_arcshare") {
        let routeData =
            nav.$router.resolve({ name: 'archss',
                                  params: { handle:v.handle,
                                            userid:v.userid }});
        window.open_if_not(routeData.href, '_blank','toolbar=0,location=0,menubar=0');
      } else if (k == "goto_room") {
        if (!v) { return; }
        if (!v.acc) {
          [v.acc,v.room] = v.room.split("/");
        }
        if (v.auto_join) {
           /* Setup room so that auto_join for "to" room can be set */
           vx_set_room(vx, v.acc, v.room);
           vx.room.auto_join = true;
        }
        nav.$router.push({
           name: "room",
           params: {acc: v.acc, uid: v.room}
        });
      } else if (k == "goto_eph") {
        let room = v;
        nav.$router.push("/room/"+room);
      } else if (k == "past_rooms") {
        if (v.cmd == "get") {
           return nav.$parent.pastRooms;
        } else if (v.cmd == "add") {
           nav.$parent.add2Past(v.name);
        }
      } else if (k == "past_phones") {
        if (v.cmd == "get") {
           return nav.pastPhones;
        } else if (v.cmd == "add") {
           nav.add2PastPhones(v.number);
        }
      } else if (k == "local_share") {
        nav.close_local_share();
        nav.local_share.open = true;
        nav.local_share.uid = v.userid;
        nav.local_share.close_cb = v.close_cb;
      } else if (k == "local_share_close") {
        if (nav.local_share && nav.local_share.uid == v.userid) {
          // eslint-disable-next-line
          console.log("close share");
          nav.close_local_share();
        }
      } else if (k == "goto_accounts") {
        nav.$parent.goAccount();
      } else if (k == "goto_home") {
        nav.$parent.goHome();
      } else if (k == "kvm_start_server") {
        if (!nav.$parent.mydevice.kvm_supported) {
          console.log("CEF: kvm_supported is false");
          v.cb && v.cb(v.kid, "server_unsupported");
          return;
        }
        console.log("CEF: kvm_supported is true");
        nav.kvm = {id:v.kid, dn:v.dn, cb:v.cb};
        nav.$bvModal.show('bv-kvm');
      } else if (k == "kvm_stop_server") {
        nav.stopKVMServer();
      } else if (k == "kvm_start_client_rq") {
        nav.kvm_client_active = true;
      } else if (k == "kvm_start_client") {
        nav.openKVMClient(v.kid, v.cb);
      } else if (k == "kvm_stop_client") {
        nav.stopKVMClient(v.kid, v.cb);
      } else if (k == "notify") {
        let nopt = v.extra || {};
        nopt.variant = (v.v || "danger");
        nopt.delay = 1000*v.c;
        nav.$parent.show_notification(v.m, nopt);
      } else if (k == "notify-close") {
        nav.$parent.close_notification(v.id);
      } else if (k == "setAudMode") {
        nav.valAudSearch = null;
        nav.$parent.setAudView(v.enable);
        nav.aud_cb = v.cb;
      } else if (k == "setMod") {
        nav.$parent.is_mod = v.is_mod || false;
        nav.$parent.is_owner = v.is_owner || false;
      } else if (k == "setCtrl") {
        nav.$parent.ctrl.state = v.state;
        nav.$parent.ctrl.privmode = v.privmode;
        if (v.viewing !== undefined) {
          nav.$parent.ctrl.viewing = v.viewing;
        }
        if (v.alert !== undefined) {
          nav.$parent.ctrl.alert = v.alert;
          /* Checkbox slider UI needs inverted state */
          nav.$parent.ctrl.alert.not_sil = !v.alert.silenced;
          /* Local var for doorbell sound */
          nav.$parent.dbell_ok = !v.alert.silenced;
        }
        if (v.event) {
           v.dname = v.dname || "";
           nav.$parent.cur_room_dname = v.dname.slice(0,12);
        } else {
           nav.$parent.cur_room_dname = "@"+nav.$router.currentRoute.params.uid;
        }
        if (v.for_mod) {
          nav.$parent.ctrl.enable_desk = v.enable_desk ? true : false;
        }
        if (v.script_handle) {
          //console.log("Transcript active");
          nav.$parent.ctrl.script_active = true;
          nav.startTranscribing();
        } else {
          //console.log("Transcript NOT active");
          nav.$parent.ctrl.script_active = false;
          nav.stopTranscribing();
        }
      } else if (k == "canTranscribe") {
        if (v === true) {
          //console.log("Can Transcribe");
          nav.transcribe.audible = true;
          nav.startTranscribing();
        } else {
          //console.log("CANNOT Transcribe");
          nav.transcribe.audible = false;
          nav.stopTranscribing();
        }
      } else if (k == "setCamOff") {
        nav.$parent.video_off = v.off;
      } else if (k == 'noaccess') {
        nav.$parent.hidePanel();
      } else if (k == 'eventid') {
        nav.$parent.eventid = v;
      } else if (k == 'panel') {
        if (v) {
          nav.$parent.showPanel();
        } else {
          nav.$parent.hidePanel();
        }
      } else if (k == 'dbell_ok') {
        return (nav.$parent.dbell_ok ? true : false);
      } else if (k == 'getasset') {
        if (v == "dbell") {
           let x = require("../assets/img/dbell.mp3");
           return x;
        } else if (v == "silence") {
           let x = require("../assets/img/silence.mp3");
           return x;
        }
      } else if (k == 'roomlist') {
        try {
           let has_bot = [];
           let km;
           v.forEach(function(u) {
             if (u.uid.indexOf("browser-bot") == 0) {
                has_bot.push(u.uid.split(".")[1] || "0");
                km = u.vt && u.vt.km;
             }
           });
           let ei = vx.room.ephidx || 0;
           ei = ""+ei;
           if (has_bot.includes(ei)) {
             nav.desktop.state = "active";
             nav.desktop.id = km;
           } else if (nav.desktop.state == "active") {
             nav.desktop.state = "off";
           }
        } catch(e) {
          console.log("navlist error",e);
        }
      } else {
        console.warn("nav:unhandled "+k);
      }
    };
    window.vx_signout_callback = function() {
      nav.$parent.signUserOut("", "You have been signed out", "warning");
    };
    let kvm = getLocal("vxkvm",true);
    if (kvm && kvm.state == "server") {
      nav.kvm_server_active = true;
    } else if (kvm && kvm.state == "access") {
      nav.kvm_client_active = true;
    } else if (kvm) {
      console.log("unknown kvm state:"+kvm.state);
      eraseLocal("vxkvm");
    }

    nav.tooltip(".ttip_capture");
    nav.tooltip(".ttip_annotate");
    nav.tooltip(".ttip_startshare");
    nav.tooltip(".ttip_stopshare");
    nav.tooltip(".ttip_settings");
  },
  methods: {
    stopKVMClient: function(id, cb) {
      let nav = this;
      console.log("KVM: stop client",id);
      if (!nav.$parent.mydevice.kvm_stop_client) {
        eraseLocal("vxkvm");
        nav.kvm_client_active = false;
        cb && cb();
        return;
      }
      nav.$parent.mydevice.kvm_stop_client(id, function() {
        eraseLocal("vxkvm");
        nav.kvm_client_active = false;
        if (cb) {
           cb();
        } else if (window.kvm_btn_state) {
          window.kvm_btn_state();
        }
      });
    },
    openKVMClient: function(id, cb) {
      if (id) {
        console.log("KVM: start client", id);
        this.$parent.mydevice.kvm_start_client && this.$parent.mydevice.kvm_start_client(id);
      }
    },
    stopKVMServer: function() {
      let nav = this;
      let kvm = getLocal("vxkvm",true);
      console.log("KVM: stop server", kvm.id);
      if (!nav.$parent.mydevice.kvm_supported) {
        eraseLocal("vxkvm");
        nav.kvm_server_active = false;
      }
      nav.$parent.mydevice.kvm_stop_server(kvm && kvm.id, function(err) {
        eraseLocal("vxkvm");
        nav.kvm_server_active = false;
      });
    },
    openKVMServer: function() {
      let nav = this;
      nav.$bvModal.hide('bv-kvm');
      if (nav.kvm.id && nav.$parent.mydevice.kvm_supported) {
        console.log("KVM: start server",nav.kvm.id);
        nav.$parent.mydevice.kvm_start_server(nav.kvm.id, function(err) {
          if (!err) {
            nav.kvm_server_active = true;
            if (nav.kvm.cb) {
               nav.kvm.cb(nav.kvm.id, "server_accept");
            }
          }
          nav.kvm = {};
        });
      }
    },
    cancelKVMServer: function() {
      let nav = this;
      nav.$bvModal.hide('bv-kvm');
      if (nav.kvm.id) {
         console.log("KVM: reject server",nav.kvm.id);
         if (nav.kvm.cb) {
            nav.kvm.cb(nav.kvm.id, "server_reject");
         }
      }
      nav.kvm = {};
    },
    startTranscribing: function() {
      let nav = this;
      if (!nav.$parent.ctrl.script_active) { return; }
      if (!nav.transcribe.audible) { return; }
      if (nav.transcribe.open) { return; }
      console.log("Start Transcribing");
      nav.transcribe.open = true;
      nav.$parent.mydevice.transcribe_start(function(ev) {
        if (ev.name == 'txt') {
          //console.log("EV-TXT",ev.txt[0].st,ev.txt[0].et,ev.txt[0].change);
          if (ev.txt[0].st && ev.txt[0].change && ev.txt[0].change.length) {
            wss_send_cb(vx, "update_transcript", {
               txt: {
                 tuid: nav.transcribe.tuid,
                 at:ev.txt[0].st,
                 val:ev.txt[0].change.join(" "),
               }
            }, function(msg) {
               //console.log("update_transcript",msg);
            });
          }
        } else if (ev.name == "open") {
            nav.transcribe.tuid = ev.tuid;
        } else if (ev.name == "close") {
            nav.transcribe.open = false;
        } else {
          //console.log("EV",ev.name);
        }
      });
    },
    stopTranscribing: function() {
      let nav = this;
      nav.transcribe.open = false;
      nav.$parent.mydevice.transcribe_stop();
    },
    goHomePrompt: function() {
      let vue = this;
      if (!window.getLocal("vx_skip_home_prompt") &&
          vue.$parent.amStreaming()) {
        vue.$bvModal.show('bv-home-prompt');
      } else {
        vue.$parent.goHome();
      }
    },
    goHomePromptClick: function() {
      let vue = this;
      if (vue.stopHomePrompt) {
        window.setLocal("vx_skip_home_prompt",1);
      }
      vue.$bvModal.hide('bv-home-prompt');
      vue.$parent.goHome();
    },
    doMute: function() {
      let vue = this;
      if (vue.do_mute) {
        vue.do_mute();
      }
    },
    doUnmute: function(ev) {
      let vue = this;
      if (vue.do_unmute) {
        vue.do_unmute(ev);
      }
    },
    doMicOn: function() {
      let nav = this;
      window.updateUserState(window.vx.room, "blk", 0, true);
    },
    doMicOff: function() {
      let nav = this;
      window.updateUserState(window.vx.room, "blk", 1, true);
    },
    doCamOn: function() {
      let nav = this;
      if (nav.$parent.mydevice.share_state != 'off') {
        nav.$parent.show_notification("Camera cannot be altered while sharing screen.");
        return;
      }

      if (!nav.$parent.mydevice.vcapturing) {
        /* Video is not yet streaming. Open the capture
           panel instead. */
        nav.$parent.enableVideoEnum();
        nav.$parent.showPanelManual();
        return;
      }
      if (nav.$parent.mydevice.vt.off == 2) {
        nav.$parent.show_notification("Camera cannot be enabled until network improves.");
        return;
      }
      nav.$parent.mydevice.vt.off = 0;
      window.update_user_assets();
      nav.$parent.mydevice.video_stream_enable(true, function() {
        nav.$parent.video_off = false;
      });
    },
    doCamOff: function() {
      let nav = this;
      if (nav.$parent.mydevice.share_state != 'off') {
        nav.$parent.show_notification("Camera cannot be altered while sharing screen.");
        return;
      }
      nav.$parent.mydevice.vt.off = 1;
      window.update_user_assets();
      nav.$parent.mydevice.video_stream_enable(false, function() {
        nav.$parent.video_off = true;
      });
    },
    testkill: function(v) {
      let nav = this;
      nav.$parent.mydevice.testkill = v;
      nav.$parent.tmp_testkill = v;
    },
    insideAdmin: function() {
      if (this.$router.currentRoute.name == "admuser" ||
          this.$router.currentRoute.name == "admacc") {
        return true;
      }
      return false;
    },
    tooltip: function(name) {
      let x = $(name);
      if(x.length && x.tooltip) { x.tooltip({container:'body'}); }     
    },
    close_local_share: function() {
      let nav = this;
      nav.local_share.open = false;
      nav.local_share.uid = null;      
      if (nav.local_share.close_cb) {
        nav.local_share.close_cb();
        nav.local_share.close_cb = null;
      }
    },
    textCapPanelJoin: function() {
      if (this.$parent.currentUser.nick == this.$router.currentRoute.params.uid) {
         return "HOST";
      }
      return "JOIN";
    },
    signOut: function() {
      this.$parent.signUserOut("", "You have been Signed Out", "warning");
    },
    debugToggle: function() {
      if (window.vx && window.vx.debug_toggle) {
        window.vx.debug_toggle();
      }
    },
    transfer_room: function(opt) {
       let nav = this;
       nav.$router.push({name: "room", params: {acc: opt.acc, uid: opt.room}});
    },
    do_search: function(opt) {
      let nav = this;
      if (nav.$route.name == "home" && window.vxHome) {
         window.vxHome.start(opt);
      } else if (nav.$route.name == "room" && nav.aud_cb) {
         if (opt.q) {
            nav.aud_cb(opt.q);
         } else {
            nav.aud_cb();
         }
      }
    },
    goSysTests: function() {
      let nav = this;
        nav.$router.push({name: 'systest'});
    },
    spawnSettings() {
      let nav = this;
      if (nav.$parent.mydevice.multi_window) {
        let url = nav.$router.resolve({name: 'settings'}).href;
        window.open_if_not(url, '_blank','width=750,height=768');
      } else {
        nav.$router.push({name: 'settings'});
      }
      nav.quickmenu = false;
    },
    spawnMirror: function() {
      let nav = this;
      let url = nav.$router.resolve({name: 'mirror'}).href;
      window.open(url,'mirrorctrl','width=325,height=500');
    },
    goAdmUsers() {
      this.$router.push({name: 'admuser'});
    },
    goAdmAcc() {
      this.$router.push({name: 'admacc'});
    },
    doRefresh() {
      window.location.reload(true);
    },
    spawnWindow() {
       let nav = this;
       let url = nav.$router.resolve({name: 'home'}).href;
       window.open_new_rt(url);
    },
    showAbout() {
      //console.log("ABOUT2:"+JSON.stringify(window.vx.about));
      let vue = this;
      vue.about = {};
      if (window.vx.about) {
        ["rel","site_version","app_version","os_version","upload_loc","download_loc","download_lat","threads"].forEach(function(f) {
          vue.about[f] = window.vx.about[f];
        });
        if (vue.$parent.mydevice.has_mse) {
          vue.about.bl = "MSE,"+vue.$parent.mydevice.pt_can_play;
        } else {
          vue.about.bl = "none,"+vue.$parent.mydevice.pt_can_play;
        }
      }
      this.$bvModal.show('bv-about');
    },
    accountClick: function() {
      let nav = this;
      nav.showaccount=!nav.showaccount;
    },
    quickClick: function() {
      let nav = this;
      nav.quickmenu=!nav.quickmenu;
      nav.quickVMPending = false;
      if (!nav.quickmenu) { return; }
      wss_send_cb(vx, "voicemail_list", {
        vm:{limit: 1},
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.vms ||
            !msg.data.vms.length) {
          return;
        }
        let v = msg.data.vms[0];
        if (!v.played) {
          /* Newest one has not been heard */
          nav.quickVMPending = true;
        }
      });
      if (nav.$parent.mydevice.aarec_get_status) {
        let s = nav.$parent.mydevice.aarec_get_status();
        nav.aarec_status = s.status;
        nav.aarec_elapsed = s.elapsed;
        nav.aarec_room = s.room;
      }
    },
    quickCtrl: function(tgt) {
      let vue = this;
      /* @change occurs before value changes in event loop so need
         to wait. Want to avoid watchers because set_ctrl only needed
         when change comes from menu vs external update */
      clearTimeout(vue.qm_tid);
      vue.qm_tid = setTimeout(function() {
        let c = { set_ctrl: {} };
        switch(""+tgt) {
        case "viewing":
          c.set_ctrl.viewing = vue.$parent.ctrl.viewing;
          c.set_ctrl.joining = vue.$parent.ctrl.viewing;
          break;
        case "dbell":
          return;
        case "privmode":
          if (vue.$parent.ctrl.privmode &&
              vue.$parent.ctrl.privmode != "false") {
            c.set_ctrl.privmode = true;
          } else {
            c.set_ctrl.privmode = false;
          }
          break;
        case "silenced":
          if (!vue.$parent.ctrl.alert) {
             /* No alerts set so nothing to silence */
             return;
          }
          c.set_ctrl.alert = {};
          if (vue.$parent.ctrl.alert.silenced) {
            c.set_ctrl.alert.silenced = false;
          } else {
            c.set_ctrl.alert.silenced = true;
          }
          //console.log("alert:"+JSON.stringify(vue.$parent.ctrl.alert));
          break;
        case "pl":
          c.set_ctrl.state = {pl: ""+vue.$parent.ctrl.state.pl};
          break;
        default:
          return;
        }
        //console.log(JSON.stringify(c));
        window.wss_send(window.vx, "set_room_ctrl", c);
      },100);
    },
    padTimeDigit(v,p) {
      return (""+v).padStart(p,"0");
    },
    quickBrowser: function(v) {
      let nav = this;
      switch(v) {
      case "start":
        window.wss_send_cb(window.vx, "shared_desktop", {
          cfg: {
            cmd: "start",
            indom: "",
          }
        }, function(msg) {
          if (msg && msg.data && msg.data.ok) {
            nav.desktop.state = "pending";
          } else {
            nav.desktop.state = "off";
          }
        });
        break;
      case "stop":
        window.wss_send_cb(window.vx, "shared_desktop", {
          cfg: {
            cmd: "stop",
            id: nav.desktop.id,
          }
        }, function(msg) {
          if (msg && msg.data && msg.data.ok) {
            nav.desktop.state = "off";
          } else {
          }
        });
      default:
      }
    },
    quickAARec: function(v) {
      let nav = this;
      switch(v) {
      case "start":
        let opt = {handle:""};
        let tm = Date.now()/100;
        while (tm > 0) {
          opt.handle = window.vx_fake62(tm) + opt.handle;
          tm = Math.trunc(tm / 62);
        }
        for (let i=0; i<10; i++) {
          opt.handle = opt.handle + window.vx_fake62(62*Math.random());
        }
        nav.$parent.mydevice.aarec_start(opt, function(s) {
           nav.aarec_status = s.status;
           nav.aarec_room = s.room;
           let e = s.elapsed;
           let rawsec = Math.trunc(e % 60);
           let sec = nav.padTimeDigit(rawsec,2);
           let min = nav.padTimeDigit(Math.trunc((e/60) % 60),2);
           let hr = Math.trunc(e/3600);
           if (e <= 0.1) {
             nav.aarec_elapsed = "...";
           } else if (e < 60) {
             nav.aarec_elapsed = `${rawsec}`;
           } else if (e < 3600) {
             nav.aarec_elapsed = `${min}:${sec}`;
           } else {
             nav.aarec_elapsed = `${hr}:${min}:${sec}`;
           }
        });
        break;
      default:
        nav.$parent.mydevice.aarec_stop();
      }
    },
    new_transcript: function() {
      wss_send_cb(vx, "new_transcript", {
      }, function(msg) {
        //console.log("new_transcript",msg);
        if (!msg || !msg.data || !msg.data.ok) {
          let err = "New transcript failed";
          if (msg && msg.data && msg.data.err) {
            err += ":"+msg.data.err;
          }
          nav.$parent.show_notification(err,{variant:"danger"});
        }
      });
    },
    stop_transcript: function() {
      wss_send_cb(vx, "stop_transcript", {
      }, function(msg) {
        //console.log("stop_transcript",msg);
        if (!msg || !msg.data || !msg.data.ok) {
          let err = "Stop transcript failed";
          if (msg && msg.data && msg.data.err) {
            err += ":"+msg.data.err;
          }
          nav.$parent.show_notification(err,{variant:"danger"});
        }
      });
    },    
    startShare: function() {
      console.log("start sharing");
      let vue = this;
      if (vue.$parent.is_mod &&
          vue.$parent.ctrl.state.pl != "1on4" &&
          vue.$parent.ctrl.state.pl != "autopt" &&
          vue.$parent.ctrl.state.pl != "2on4") {
         let c = { set_ctrl: {} };
         c.set_ctrl.state = vue.$parent.ctrl.state;
         c.set_ctrl.state.pl = "autopt";
         //console.log(JSON.stringify(c));
         window.wss_send(window.vx, "set_room_ctrl", c);
      }
      vue.$parent.mydevice.share_state = "sharing";
      vue.$parent.mydevice.start_share({}, function(err/*,data*/) {
      });
    },
    stopShare: function() {
      // eslint-disable-next-line
      console.log("stop sharing");
      let vue = this;
      let opt = {};
      vue.$parent.mydevice.stop_share(opt, function(/*err,data*/) {
      });
    },
    swapShare: function() {
      // eslint-disable-next-line
      console.log("swap share");
      let vue = this;
      let opt = {};
      vue.$parent.mydevice.swap_share(opt, function(/*err,data*/) {
      });
    },
    openAnnotation: function() {
      let vue = this;
      let opt = {};
      if (vue.$parent.mydevice.annotate_url) {
         opt.url = vue.$parent.mydevice.annotate_url;
         vue.$parent.mydevice.open_annotator(opt, function(/*err,data*/) {
         });
         window.vx.user.ss_an = opt.url.split("?")[0];
         window.update_user_assets();
      } else {
        vx_api.createShare(window.vx, {kind:"share_img_an"}).then(stream => {
           opt.url = stream.upload.vxshare;
           if (opt.url) {
             vue.$parent.mydevice.annotate_url = opt.url;
             vue.$parent.mydevice.open_annotator(opt, function(/*err,data*/) {
             });
             window.vx.user.ss_an = opt.url.split("?")[0];
             window.update_user_assets();
           }
        });
      }
    },
    closeAnnotation: function() {
      let vue = this;
      if (vue.$parent.mydevice.annotate_url) {
         vue.$parent.mydevice.annotate_url = null;
         window.vx.user.ss_an = "-";
         window.update_user_assets();
         vue.$parent.mydevice.close_annotator({});
      }
    },
    loadPastPhones: function() {
      let vue = this;
      vue.pastPhones = getLocal("vxphonepast",true) || [];
    },
    add2PastPhones: function(name) {
      let vue = this;
      let arr = [ name ];
      if (!name) { return; }
      for (let i=0; i<5 && i<vue.pastPhones.length; i++) {
        if (vue.pastPhones[i] != name) {
          arr.push(vue.pastPhones[i]);
        }
      }
      vue.pastPhones = arr;
      setLocal("vxphonepast",JSON.stringify(vue.pastPhones));
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.optrooms {
  display:none;
  position:absolute;
  top:50px;
  background:#1a1a1d;
  border-radius: 0.25rem;
}
#roominput:focus + .optrooms {
  display:block;
  z-index:10;
}
.optrooms:hover, .optrooms:focus {
  display:block;
  z-index:10;
}

.my-dropdown {
  display:block;
  padding:0.25rem;
  margin:0;
}

.quickmenu {
  display:block;
  padding:0.25rem;
  margin:0;
  font-size:0.9rem;
}

.quickmenu_item {
  display:inline-block;
  font-size:0.65rem;
  text-transform:uppercase;
  width:3.2rem;
}

.quickmenu_vm {
  font-size:0.7rem;
  text-transform:uppercase;
  border: 1px solid #d02020;
  border-radius: 0.5rem;
  background-color: #f0e0e0;
}

.quickmenu_all {
  color:#007bff !important;
  cursor:pointer;
  font-size:0.7rem;
  text-transform:uppercase;
}

.quickmenu_val {
  font-size:0.75rem;
  text-transform:uppercase;
}

.quickmenu_aabtn {
  position:relative;
  font-size:0.65rem;
  color:white;
  border:none;
  text-transform:uppercase;
  padding: 0;
  width: 100%;
}
.quickmenu_aahov {
  display:none;
  position:absolute;
  width:100%;
  top:-1rem;
  text-align:center;
  font-size:0.65rem;
  font-weight: bold;
  z-index:2;
  background-color:rgba(154,224,220,0.9);
  color:black;
  border-radius:5px;
}
.quickmenu_aabtn:hover + .quickmenu_aahov {
  display:block;
}

.quickmenu_aastop {
  font-family:'Material Icons';
  text-transform:none;
  font-size: 1rem;
  vertical-align: middle;
  line-height:0;
}
.quickmenu_aaelp {
  text-transform:none;
}

.quickmenu_script {
  position:relative;
  font-size:0.65rem;
  color:white;
  border:none;
  text-transform:uppercase;
  padding: 0;
  width: 100%;
}

.quickmenu_deskbtn {
  position:relative;
  font-size:0.65rem;
  text-transform:uppercase;
  padding: 0;
  width: 100%;
}

</style>
